<app-overview [overviewFilters]="filters.overviewFilters" [searchFunction]="searchTermFunction"
              (resultsFound)="renderRecords($event, false)"
              [isEmpty]="isEmpty" [facetNameFormatter]="nameFormatter" [facetsLoading]="facetsLoading" [facets]="facets"
              [otherFacets]="otherFacets"
              (facetFiltersChanged)="facetFiltersChanged($event)" (loadNextPage)="loadNextPage()"
              (filtersCleared)="clearFilters($event)"
              [quickViews]="quickViews" [specificFacetFiltersTemplate]="specificFacetFilters">
  <div class="header-bar d-flex">
    @if (appContext.isVisitDeclarant()) {
      <a type="button" class="btn btn-primary text-decoration-none" [routerLink]="'/newVisit'">
        <i class="button-icon fa-light fa-plus"></i>
        <span class="ps-2 d-none d-lg-inline">New visit</span>
      </a>
    }
    <button class="btn btn-link link-primary text-decoration-none" (click)="export()">
      <i class="me-xl-2 d-lg-inline-block button-icon fa-light fa-arrow-down-to-line"></i>
      <span class="d-none d-xl-inline-block">Download</span>
    </button>
    @if (!appContext.isAdmin()) {
      <div class="d-flex align-items-center ms-3">
        <div class="dropdown">
          <button class="btn btn-plain text-primary d-inline-flex align-items-center py-1 p-lg-2 p-1"
                  data-bs-toggle="dropdown" aria-expanded="false">
            <div class="d-none d-lg-block">
              {{ ownCallsFormatter(filters?.ownCallsOnly) }}
              <div class="d-inline-block"><i class="fa fa-fw fa-light fa-chevron-down ms-1"></i></div>
            </div>
            <div class="d-block d-lg-none">
              <div class="d-inline-block">
                <i class="fa fa-fw fa-light fa-eye"></i>
              </div>
            </div>
          </button>
          <ul class="dropdown-menu">
            <li>
              <button class="dropdown-item d-flex justify-content-between px-3"
                      [ngClass]="filters?.ownCallsOnly ? 'text-primary' : ''" (click)="setOwnsCallsOnly(true)">
                <span>{{ ownCallsFormatter(true) }}</span>
                @if (filters?.ownCallsOnly) {
                  <i class="fa fa-fw fa-light fa-check"></i>
                }
              </button>
            </li>
            <li>
              <button class="dropdown-item d-flex justify-content-between px-3"
                      [ngClass]="!filters?.ownCallsOnly ? 'text-primary' : ''" (click)="setOwnsCallsOnly(false)">
                <span>{{ ownCallsFormatter(false) }}</span>
                @if (!filters?.ownCallsOnly) {
                  <i class="fa fa-fw fa-light fa-check"></i>
                }
              </button>
            </li>
          </ul>
        </div>
      </div>
    }
    <div class="d-none d-sm-flex align-items-center ms-3">
      <span class="text-muted">
        <app-loading-icon [loading]="facetsLoading">{{ totalCount }}</app-loading-icon>
        visits
      </span>
    </div>
    <div class="d-flex align-items-center ms-3">
      <div class="dropdown">
        <button class="btn btn-plain text-primary d-inline-flex align-items-center py-1 p-lg-2 p-1"
                data-bs-toggle="dropdown" aria-expanded="false">
          <div class="d-none d-lg-block">
            {{ sortingFormatter(sortingProperty) }}
            <div class="d-inline-block"><i class="fa fa-fw fa-light fa-chevron-down ms-1"></i></div>
          </div>
          <div class="d-block d-lg-none">
            <div class="d-inline-block">
              <i class="fa fa-fw fa-light fa-long-arrow-up"></i>
              <i class="fa fa-fw fa-light fa-long-arrow-down" [style.margin-left.rem]="-0.7"></i>
            </div>
          </div>
        </button>
        <ul class="dropdown-menu">
          @for (property of sortingProperties; track property) {
            <li>
              <button class="dropdown-item d-flex justify-content-between px-3"
                      [ngClass]="sortingProperty === property ? 'text-primary' : ''"
                      (click)="changeSorting(property)">
                <span>{{ sortingFormatter(property) }}</span>
                @if (sortingProperty === property) {
                  <i class="fa fa-fw fa-light fa-check"></i>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
  <div class="overview-items">
    @for (summary of data; track summary.crn) {
      <app-emergency-overview-item [summary]="summary" [term]="searchTerm"></app-emergency-overview-item>
    }
  </div>
  <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
    <img src="/assets/new-portvisit/no-results-icon-port-visit.svg" alt="No visits found icon" class="mb-2"/>
    <span class="h1 mb-2">No ship ahoy...</span>
    @if (filters.overviewFilters.selectedQuickView !== quickViews[0]) {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
          <span> or go to the </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{ quickViews[0].name }}</span>
          <span> quick view</span>
        </span>
      } @else {
        <span class="text-secondary">
          <span>Try going to the </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{ quickViews[0].name }}</span>
          <span> quick view</span>
        </span>
      }
    } @else {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
        </span>
      } @else {
        <span class="text-secondary">Try adjusting your filters or search term</span>
      }
    }
  </div>
</app-overview>
<ng-template #specificFacetFilters>
  <div class="col-md-12">
    <app-facet-date-range [ranges]="ranges" [filterName]="'Arrival date'" (ngModelChange)="arrivalDateChanged($event)"
                          [(ngModel)]="filters.overviewFilters.filters.timeRange"></app-facet-date-range>
  </div>
</ng-template>
